import React from "react";
import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import ReRegistrationCourseForm, { ReRegistrationCourseFormItem } from "../../../../forms/recadastramento/ReRegistrationCourseForm";

import TmpInputCustom, { InputMaskProps } from "../../../../components/tempo/TmpInputCustom/TmpInputCustom";
import TmpTableBaseCustom, { ITableColumnsProps } from "../../../../components/tempo/TmpTableBaseCustom/TmpTableBaseCustom";
import TmpButtonCustom from "../../../../components/tempo/TmpButtonCustom/TmpButtonCustom";


interface ReRegistrationCourseComponentProps {
    ReRegistrationCourseForm: ReRegistrationCourseForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: ReRegistrationCourseFormItem) => void
    onDeleteClick: (e: ReRegistrationCourseFormItem) => void
    onCancelItem: () => void
}

export default function ReRegistrationCourseComponent(props: ReRegistrationCourseComponentProps) {

    const headers: ITableColumnsProps[] = [
        { title: "Curso", align: "center", property: "Course", type: "text" },
        { title: "Instituição", align: "center", property: "Institution", type: "text" },
        { title: "Ano de conclusão", align: "center", property: "YearCompletion", type: "text" },
    ]

    return (

        <Grid container spacing={3}>

            <Grid item xs={5} sm={5}>
                <TmpInputCustom
                    label="Curso *"
                    id="Course"
                    name="Course"
                    type="text"
                    maxLength={100}
                    placeholder="Digite o ano de conclusão"
                    value={props.ReRegistrationCourseForm.Course.Value}
                    onChange={(e) => {
                        props.onInputChange("Course", props.ReRegistrationCourseForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Course", props.ReRegistrationCourseForm, e.target.value);
                    }}
                    error={props.ReRegistrationCourseForm.Course.HasError()}
                    helperText={props.ReRegistrationCourseForm.Course.Error}

                />

            </Grid>

            <Grid item xs={4} sm={4}>
                <TmpInputCustom
                    label="Instituição *"
                    id="Institution"
                    name="Institution"
                    type="text"
                    maxLength={80}
                    placeholder="Digite o nome da instituição"
                    value={props.ReRegistrationCourseForm.Institution.Value}
                    onChange={(e) => {
                        props.onInputChange("Institution", props.ReRegistrationCourseForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Institution", props.ReRegistrationCourseForm, e.target.value);
                    }}
                    error={props.ReRegistrationCourseForm.Institution.HasError()}
                    helperText={props.ReRegistrationCourseForm.Institution.Error}

                />

            </Grid>



            <Grid item xs={3} sm={3}>
                <TmpInputCustom
                    id="YearCompletion"
                    name="YearCompletion"
                    label="Ano de conclusão *"
                    maxLength={4}
                    type="text"
                    mask={InputMaskProps.NUMERICO}
                    placeholder="Digite o ano de conclusão"
                    value={props.ReRegistrationCourseForm.YearCompletion.Value}
                    onChange={(e) => {
                        props.onInputChange("YearCompletion", props.ReRegistrationCourseForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("YearCompletion", props.ReRegistrationCourseForm, e.target.value);
                    }}
                    error={props.ReRegistrationCourseForm.YearCompletion.HasError()}
                    helperText={props.ReRegistrationCourseForm.YearCompletion.Error}
                />
            </Grid>



            <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                    {(props.ReRegistrationCourseForm.FormItemToEdit.Id > 0 ?
                        <TmpButtonCustom id={"cancelar"} type="secondary" typeButton="button" size="sm" handleClick={props.onCancelItem}>
                            Cancelar edição curso
                        </TmpButtonCustom>
                        : null
                    )}

                    {(props.ReRegistrationCourseForm.FormItemToEdit.Id === 0 ?
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Adicionar curso
                        </TmpButtonCustom>
                        :
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Salvar curso
                        </TmpButtonCustom>
                    )}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <TmpTableBaseCustom
                    columns={headers}
                    actionEditColumn={true}
                    actionDeleteColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick}
                    rows={props.ReRegistrationCourseForm.FormItemList}
                />
            </Grid>

        </Grid>

    )

}